module.exports = __webpack_public_path__ + "img/red_024.a69549f0.png";